/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet-async";

const Services = () => {

  const phoneNumber = "6394941232";

  const handleWhatsAppBooking = (serviceName) => {

    const message =
      `Hello, I want to book ${serviceName} service. Please share price & available slots.`;

    const url =
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message
      )}`;

    window.open(url, "_blank");

  };

  const services = [

    {
      title: "Hair Styling",
      img: "https://g3luxurysalon.com/assets/images/home1-banner.webp",
      list: [
        "Ladies Hairstyle",
        "Hair Styling",
        "Hair Cut",
        "Ironing",
        "Blow Dry",
        "Roller Setting",
        "Oiling",
      ],
    },

    {
      title: "Hair Colour & Care",
      img: "https://btanishsalon.com/wp-content/uploads/2024/11/IMG_2112-scaled.jpg",
      list: [
        "Global Colouring",
        "Root Touch Up",
        "Shampoo & Conditioning",
        "Head Massage",
        "Colour Protection",
        "Volumizing",
      ],
    },

    {
      title: "Make Up Services",
      img: "https://www.bodycraft.co.in/hubfs/unnamed%20(17)-3.png",
      list: [
        "Make Up",
        "Party Make Up",
        "Engagement Make Up",
        "Bridal & Reception Make Up",
        "Base Make Up",
        "Eye Make Up",
      ],
    },

    {
      title: "Hair Texture",
      img: "https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=1200",
      list: [
        "Rebonding",
        "Perming",
        "Keratin",
        "Smoothening",
      ],
    },

    {
      title: "Hair Treatments",
      img: "https://drhanandermatologyclinic.com/wp-content/uploads/2025/01/woman-doing-herself-scalp-massage-1024x683.jpg",
      list: [
        "Spa Treatments",
        "Advanced Hair Moisturising",
        "Scalp Treatments",
        "Hair Treatments",
      ],
    },

    {
      title: "Facial Services",
      img: "https://faceyogabyhouseofbeauty.com/cdn/shop/files/Eyecial_for_dark_cricles.jpg?v=1759225020&width=3840",
      list: [
        "Facials & Rituals",
        "Bleach",
        "Luxury Facials/Rituals",
        "Clean Ups",
        "Body Polishing/Rejuvenation",
      ],
    },

    {
      title: "Threading & Waxing",
      img: "https://bayouspa.com/cdn/shop/articles/Threadng_1500x.jpg?v=1720804572",
      list: [
        "Threading",
        "Waxing",
      ],
    },

    {
      title: "Hand & Feet Care",
      img: "https://thumbs.dreamstime.com/b/woman-hands-nail-salon-receiving-hand-scrub-peeling-beautician-spa-manicure-massage-body-care-treatments-close-up-195648051.jpg",
      list: [
        "Manicure",
        "Spa Pedicure",
        "Pedicure",
        "Spa Manicure",
      ],
    },

    {
      title: "Nail Care",
      img: "https://images.unsplash.com/photo-1607779097040-26e80aa78e66?q=80&w=1200",
      list: [
        "Nail Care",
        "Nail Paint",
        "Nail Art",
        "Nail Filling",
      ],
    },

  ];

  const feedbacks = [

    {
      text: "Thank you for your amazing work. I’ve never looked so beautiful before and the entire experience felt relaxing and luxurious.",
      name: "Ashish Pandey",
      location: "Prayagraj",
    },

    {
      text: "The staff was friendly, skilled and made me feel comfortable throughout. Clean ambience and attention to detail were impressive.",
      name: "Sakshi Singh",
      location: "Prayagraj",
    },

    {
      text: "The staff is very courteous, services are on time and pricing is reasonable. You can visit without any hesitation.",
      name: "Amrita Pandey",
      location: "Jhusi",
    },

    {
      text: "Amazing experience with sweet and polite staff. They made sure I felt comfortable throughout the entire visit.",
      name: "Medhavi Kesharwani",
      location: "Prayagraj",
    },

    {
      text: "Had the best experience at this salon. The treatment was amazing and the staff were highly professional.",
      name: "Ankita",
      location: "Prayagraj",
    },

    {
      text: "I booked my engagement makeover here and absolutely loved the services, ambience and staff behaviour.",
      name: "Sandhya Singh",
      location: "Prayagraj",
    },

    {
      text: "They genuinely created my dreamy look exactly the way I wanted. Staffs are very cooperative and talented.",
      name: "Yogita Mishra",
      location: "Prayagraj",
    },

    {
      text: "Booked party makeup and received so many compliments. The makeup artist understood my requirements perfectly.",
      name: "Abha Shri",
      location: "Prayagraj",
    },

  ];

  return (
    <>

    <Helmet>

      <title>
        Bridal Makeup, Facial & Hair Styling
        Services in Prayagraj Jhusi
      </title>

      <meta
        name="description"
        content="
        Explore luxury bridal makeup, facial,
        hair styling, nail care and beauty salon
        services in Prayagraj Jhusi.
        "
      />

    </Helmet>

    
      <style>
        {`

@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Manrope:wght@300;400;500;600;700&display=swap');

:root{
  --primary:#ffffff;
  --secondary:#d6d6d6;
  --gold:#ffffff;
  --dark:#050505;
  --light:#0b0b0b;
  --text:#cfcfcf;
}

body{
  background:var(--light);
  overflow-x:hidden;
  font-family:'Manrope',sans-serif;
}

.luxury-heading{
  font-family:'Cormorant Garamond',serif;
}

.section-heading{
  font-size:clamp(55px,6vw,85px);
  line-height:1;
  color:#fff;
}

.section-description{
  color:rgba(255,255,255,0.72);
  max-width:720px;
  margin:20px auto 70px;
  line-height:2;
  font-size:16px;
}

.section-tag{
  font-size:20px;
  text-decoration:underline;
  color:white;
  text-decoration-color:rgba(255,255,255,0.45);
  letter-spacing:2px;
  font-weight:600;
}
.service-card{

  background:
    linear-gradient(
      to bottom,
      rgba(20,20,20,0.96),
      rgba(10,10,10,0.96)
    );

  backdrop-filter:blur(22px);

  border:
    1px solid rgba(255,255,255,0.08);

  border-radius:36px;

  overflow:hidden;

  transition:all .55s ease;

  height:100%;

  position:relative;

  display:flex;
  flex-direction:column;

  box-shadow:
    0 25px 70px rgba(0,0,0,0.5);
}

.service-card:hover{

  transform:
    translateY(-16px)
    scale(1.02);

  border:
    1px solid rgba(255,255,255,0.18);

  box-shadow:
    0 40px 90px rgba(255,255,255,0.06);
}

.service-card::before{

  content:'';

  position:absolute;

  top:0;
  left:0;

  width:100%;
  height:2px;

  background:
    linear-gradient(
      to right,
      transparent,
      rgba(255,255,255,0.7),
      transparent
    );

  opacity:.7;
}

.service-card img{
  transition:all .8s ease;
}

.service-card:hover img{
  transform:scale(1.08);
}

.premium-btn{
  position:relative;
  overflow:hidden;
  transition:all .45s ease;
}

.premium-btn:hover{
  transform:translateY(-4px);

  box-shadow:
    0 20px 40px rgba(255,255,255,0.12);
}

.premium-btn::before{
  content:'';
  position:absolute;
  top:0;
  left:-120%;
  width:100%;
  height:100%;
  background:rgba(255,255,255,0.25);
  transform:skewX(-20deg);
  transition:.7s;
}

.premium-btn:hover::before{
  left:120%;
}

.services-glow{

  position:absolute;

  width:500px;
  height:500px;

  background:
    radial-gradient(
      circle,
      rgba(255,255,255,0.08),
      transparent 70%
    );

  filter:blur(60px);

  top:-120px;
  right:-120px;
}

@keyframes fadeUp{

  from{
    opacity:0;
    transform:translateY(60px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }
}

@media(max-width:768px){

  .section-heading{
    font-size:52px !important;
  }

}

`}
      </style>

      {/* SERVICES */}

      <section
        style={{
          padding:"140px 0 120px",
          background:
            "linear-gradient(to bottom,#050505,#111111)",
          position:"relative",
          overflow:"hidden",
        }}
      >

        <div className="services-glow"></div>

        <div className="container text-center">

          <p className="section-tag">
           OUR SERVICES
          </p>

          <h2 className="luxury-heading section-heading">
            Beauty Services
          </h2>

          <p className="section-description">
            Discover premium beauty and wellness services
            tailored specially for your luxury salon experience.
          </p>

          <div className="row mt-5 g-4">

            {services.map((item, i) => (

              <div className="col-lg-4 col-md-6" key={i}>

                <div className="service-card">

                  <div
                    style={{
                      overflow:"hidden",
                    }}
                  >

                    <img
                      src={item.img}
                      alt=""
                      style={{
                        width:"100%",
                        height:"320px",
                        objectFit:"contain",
                      }}
                    />

                  </div>

                  {/* <div className="p-4 d-flex flex-column h-100">

                    <h3
                      className="luxury-heading"
                      style={{
                        fontSize:"38px",
                        color:"#fff",
                      }}
                    >
                      {item.title}
                    </h3>

                    <ul
                      style={{
                        textAlign:"left",
                        marginTop:"20px",
                        flexGrow:1,
                        padding:0,
                        listStyle:"none",
                      }}
                    >

                      {item.list.map((li, idx) => (

                        <li
                          key={idx}
                          style={{
                            marginBottom:"16px",
                            paddingBottom:"16px",
                            borderBottom:
                              "1px solid rgba(255,255,255,0.06)",
                          }}
                        >

                          <span
                            style={{
                              color:"rgba(255,255,255,0.82)",
                              fontSize:"15px",
                              fontWeight:"500",
                              letterSpacing:"0.4px",
                            }}
                          >
                            ✦ {li}
                          </span>

                        </li>

                      ))}
                        <button
                      onClick={() =>
                        handleWhatsAppBooking(item.title)
                      }
                      className="premium-btn mt-3"
                      style={{
                        background:"#ffffff",
                        color:"#000",
                        border:
                          "1px solid rgba(255,255,255,0.08)",
                        padding:"14px",
                        borderRadius:"50px",
                        fontWeight:"700",
                        width:"100%",
                        boxShadow:
                          "0 10px 30px rgba(255,255,255,0.08)",
                      }}
                    >
                      Book {item.title}
                    </button>
                    </ul>

                 

                  </div> */}
<div className="p-4 d-flex flex-column h-100">

  <h3
    className="luxury-heading"
    style={{
      fontSize:"38px",
      color:"#fff",
    }}
  >
    {item.title}
  </h3>

  <ul
    style={{
      textAlign:"left",
      marginTop:"20px",
      flexGrow:1,
      padding:0,
      listStyle:"none",
      display:"flex",
      flexDirection:"column",
    }}
  >

    {item.list.map((li, idx) => (

      <li
        key={idx}
        style={{
          marginBottom:"16px",
          paddingBottom:"16px",
          borderBottom:
            "1px solid rgba(255,255,255,0.06)",
        }}
      >

        <span
          style={{
            color:"rgba(255,255,255,0.82)",
            fontSize:"15px",
            fontWeight:"500",
            letterSpacing:"0.4px",
          }}
        >
          ✦ {li}
        </span>

      </li>

    ))}

  </ul>

  {/* BUTTON */}

  <button
    onClick={() =>
      handleWhatsAppBooking(item.title)
    }
    className="premium-btn mt-auto"
    style={{
      background:"#ffffff",
      color:"#000",
      border:
        "1px solid rgba(255,255,255,0.08)",
      padding:"14px",
      borderRadius:"50px",
      fontWeight:"700",
      width:"100%",
      marginTop:"25px",
      boxShadow:
        "0 10px 30px rgba(255,255,255,0.08)",
    }}
  >
    Book {item.title}
  </button>

</div>
                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* TESTIMONIALS */}

      <section
        style={{
          padding:"140px 0",
          background:
            "linear-gradient(to bottom,#050505,#111111)",
          position:"relative",
          overflow:"hidden",
        }}
      >

        {/* GLOW */}

        <div
          style={{
            position:"absolute",
            width:"500px",
            height:"500px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.08), transparent 70%)",
            top:"-150px",
            left:"-120px",
            filter:"blur(70px)",
          }}
        />

        <div
          style={{
            position:"absolute",
            width:"400px",
            height:"400px",
            background:
              "radial-gradient(circle, rgba(255,255,255,0.08), transparent 70%)",
            bottom:"-120px",
            right:"-120px",
            filter:"blur(70px)",
          }}
        />

        <div className="container position-relative">

          <div className="text-center mb-5">

            <p
              className="section-tag"
              style={{
                color:"#ffffff",
                fontSize:"18px",
                letterSpacing:"5px",
              }}
            >
              CLIENT LOVE
            </p>

            <h2
              className="luxury-heading section-heading"
              style={{
                fontSize:"clamp(55px,6vw,90px)",
                color:"#fff",
                lineHeight:"1",
              }}
            >
              What Clients Say
            </h2>

            <p
              style={{
                maxWidth:"700px",
                margin:"25px auto 0",
                color:"rgba(255,255,255,0.65)",
                lineHeight:"2",
                fontSize:"16px",
              }}
            >
              Real experiences from our happy clients who trusted
              us for their beauty and luxury salon journey.
            </p>

          </div>

          <div className="row g-4 mt-2">

            {feedbacks.map((item, i) => (

              <div className="col-lg-6" key={i}>

                <div
                  style={{
                    background:
                      "linear-gradient(to bottom, rgba(255,255,255,0.08), rgba(255,255,255,0.03))",

                    backdropFilter:"blur(20px)",

                    border:
                      "1px solid rgba(255,255,255,0.08)",

                    borderRadius:"35px",

                    padding:"45px",

                    height:"100%",

                    position:"relative",

                    overflow:"hidden",

                    transition:"0.5s",

                    boxShadow:
                      "0 20px 60px rgba(0,0,0,0.45)",
                  }}
                  onMouseOver={(e) => {

                    e.currentTarget.style.transform =
                      "translateY(-10px)";

                    e.currentTarget.style.border =
                      "1px solid rgba(255,255,255,0.18)";

                    e.currentTarget.style.boxShadow =
                      "0 30px 80px rgba(255,255,255,0.08)";

                  }}
                  onMouseOut={(e) => {

                    e.currentTarget.style.transform =
                      "translateY(0px)";

                    e.currentTarget.style.border =
                      "1px solid rgba(255,255,255,0.08)";

                    e.currentTarget.style.boxShadow =
                      "0 20px 60px rgba(0,0,0,0.45)";

                  }}
                >

                  <div
                    style={{
                      position:"absolute",
                      top:"20px",
                      right:"30px",
                      fontSize:"90px",
                      color:"rgba(255,255,255,0.08)",
                      fontFamily:"serif",
                    }}
                  >
                    ”
                  </div>

                  <div
                    style={{
                      color:"#ffffff",
                      fontSize:"22px",
                      letterSpacing:"3px",
                    }}
                  >
                    ★★★★★
                  </div>

                  <p
                    style={{
                      marginTop:"28px",
                      lineHeight:"2",
                      color:"#e8e8e8",
                      fontSize:"16px",
                    }}
                  >
                    {item.text}
                  </p>

                  <div
                    className="d-flex align-items-center gap-3 mt-4"
                  >

                    <div>

                      <h5
                        style={{
                          margin:0,
                          color:"#fff",
                          fontWeight:"700",
                        }}
                      >
                        {item.name}
                      </h5>

                      <small
                        style={{
                          color:"#cfcfcf",
                          letterSpacing:"1px",
                        }}
                      >
                        {item.location}
                      </small>

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </div>

        <a
  href="https://search.google.com/local/writereview?placeid=ChIJD82fbSJLhTkRx3xgW2XB94U"
  target="_blank"
  rel="noopener noreferrer"
    style={{
      textDecoration:"none",
      width:"100%",
      maxWidth:"320px",
    }}
  >

   <div
  style={{
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    marginTop:"50px",
    width:"100%",
  }}
>
  <button
    className="premium-btn"
    style={{
      width:"fit-content",
      minWidth:"260px",

      background:
        "linear-gradient(to right,#ffffff,#d9d9d9)",

      color:"#000",

      border:"none",

      padding:"18px 28px",

      borderRadius:"70px",

      fontWeight:"700",

      letterSpacing:"1px",

      fontSize:"16px",

      display:"flex",

      alignItems:"center",

      justifyContent:"center",

      gap:"12px",

      boxShadow:
        "0 15px 45px rgba(255,255,255,0.12)",

      transition:"0.4s ease",
    }}
    onMouseOver={(e) => {
      e.currentTarget.style.transform =
        "translateY(-5px) scale(1.02)";

      e.currentTarget.style.boxShadow =
        "0 25px 60px rgba(255,255,255,0.18)";
    }}
    onMouseOut={(e) => {
      e.currentTarget.style.transform =
        "translateY(0px) scale(1)";

      e.currentTarget.style.boxShadow =
        "0 15px 45px rgba(255,255,255,0.12)";
    }}
  >
    ⭐ Drop Your Review
  </button>
</div>

  </a>
        </div>
    
      </section>

      {/* CTA */}

      <section
        style={{
          padding:"120px 0",
          background:
            "linear-gradient(to right,#050505,#151515,#050505)",
          textAlign:"center",
          color:"white",
        }}
      >

        <div className="container">

          <h2
            className="luxury-heading section-heading"
            style={{
              fontSize:"clamp(60px,7vw,90px)",
              lineHeight:"1",
            }}
          >
            Ready For Your <br />
            Luxury Makeover?
          </h2>

          <p
            style={{
              maxWidth:"720px",
              margin:"30px auto",
              lineHeight:"2",
              color:"#f7f7f7",
            }}
          >
            Experience premium salon care and timeless elegance
            crafted specially for you.
          </p>

          <button
            onClick={() =>
              handleWhatsAppBooking("Beauty Service")
            }
            className="premium-btn"
            style={{
              background:"white",
              color:"#000",
              border:"none",
              padding:"18px 45px",
              borderRadius:"60px",
              fontWeight:"700",
            }}
          >
            Book Appointment
          </button>

           
        </div>

      </section>

    </>
  );

};

export default Services;